import React from "react"
import styled from "styled-components"
import { ValueView } from "components/atoms/ValueView"
import { ApplicationSummaryEnhanced } from "models/ApplicationSummaryEnhanced"
import { OpportunityStage } from "models/FullApplication"

const AppStageText = styled.div`
  text-align: center;
  width: 100%;
  color: ${(props) => props.theme.primary};
  font-size: 0.9em;
`

// This used to work from.the flags but seems somewhat pointless. We can work them out using the below.
export function AppStageBadge({ application }: { application: ApplicationSummaryEnhanced }) {
  const getStatusText = (): string => {
    const { tls, offeredAppointment, stage, hasAppointments } = application

    if (tls.team === "Specialist") return "Specialist Help"

    if (!tls.appointmentOffered && !offeredAppointment && !hasAppointments) {
      return "Can‘t Help"
    }

    switch (stage) {
      case OpportunityStage.dip:
        return "Decision in Principle"
      case OpportunityStage.quoted:
        return "Recommendation"
      case OpportunityStage.online:
      case OpportunityStage.factfind:
        return "Mortgage Ready"
      default:
        return stage
    }
  }

  return <ValueView value={<AppStageText>{getStatusText()}</AppStageText>} />
}
